import type { NetworkConnectionType, NetworkPort } from "../../ports/network.port";

/**
 * Подмножество Network Information API. Типов в lib.dom нет — объявляем сами,
 * и только те поля, которым доверяем (см. комментарий в `getConnectionType`).
 */
interface NetworkInformationLike {
	saveData?: boolean;
}

function connection(): NetworkInformationLike | undefined {
	if (typeof navigator === "undefined") return undefined;
	return (navigator as Navigator & { connection?: NetworkInformationLike }).connection;
}

// Web network status: navigator.onLine + online/offline events.
export const networkWebAdapter: NetworkPort = {
	async isOnline() {
		return typeof navigator === "undefined" ? true : navigator.onLine;
	},
	onChange(handler) {
		if (typeof window === "undefined") return () => {};
		const on = () => handler(true);
		const off = () => handler(false);
		window.addEventListener("online", on);
		window.addEventListener("offline", off);
		return () => {
			window.removeEventListener("online", on);
			window.removeEventListener("offline", off);
		};
	},

	/**
	 * ВАЖНОЕ РЕШЕНИЕ: на web мы НЕ пытаемся определить реальный тип канала.
	 *
	 * `navigator.connection.type` не реализован в Safari и Firefox, а в
	 * Chromium возвращает `'unknown'` на десктопе; `effectiveType` описывает
	 * СКОРОСТЬ (`4g` на быстром Wi-Fi и на быстром LTE одинаково), а не
	 * тарифицируемость. Угадывание «cellular» по этим полям давало бы ложные
	 * запреты на предзагрузку у людей на обычном домашнем интернете.
	 *
	 * Поэтому политика web-адаптера: онлайн ⇒ считаем канал не-metered
	 * (`'wifi'`), а единственный сигнал экономии трафика, которому мы верим, —
	 * явный `saveData` (его пользователь включает сам). На Capacitor тип
	 * канала берётся из нативного API и там он достоверен.
	 */
	async getConnectionType(): Promise<NetworkConnectionType> {
		if (typeof navigator === "undefined") return "unknown";
		if (!navigator.onLine) return "none";
		return "wifi";
	},

	async isSaveData(): Promise<boolean> {
		return connection()?.saveData === true;
	},
};
